import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { getSchoolsFromSite } from 'global/viewSettings/importing/stateResults'
import React, { useCallback, useContext, useState } from 'react'
import { SportsDistrictContext } from '../cnr/contexts/SportsDistrictContext'
import { getStatePaSchoolData } from 'global/viewSettings/importing/schoolResults'

export const useSchools = () => {

  const parentContext = useContext(ParentContext)
  const { fn_cls } = parentContext ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district, district_data } = sportsDistrict_state ?? {}
  const { districtId } = district ?? {}

  const [updating, setUpdating] = useState()
  const [districtSchools, setDistrictSchools] = useState()
  const [districtSchoolsData, setDistrictSchoolsData] = useState()

  const getSchools_fromSite = useCallback(() => {
    const cb = (results) => {
      if (results) {
        setDistrictSchools(results)
        // const districts = _.groupBy(results, 'district');
        // setDistrictSchools(districts)
        // setAllDistrictKeys(districts ? Object.keys(districts) : [])
        setUpdating(false)
      }
    }
    setUpdating(true)
    getSchoolsFromSite(fn_cls, districtId, cb)
  }, [])

  const getSchools_paData = useCallback(async ({ schools, callback }) => {
    setUpdating(true)
    const xx = await getStatePaSchoolData(schools, fn_cls)
    console.log('xx', xx)
    setDistrictSchoolsData(xx)
    setUpdating(false)
  }, [])

  return { getSchools_fromSite, getSchools_paData, updating, districtSchools, districtSchoolsData }
}
